export default {
    en: [
        {
            label: "House",
            value: "House"
        },
        {
            label: "Condo",
            value: "Condo"
        },
        {
            label: "Secondary home or cottage",
            value: "Secondary home or cottage"
        },
        {
            label: "Duplex",
            value: "Duplex"
        },
        {
            label: "Triplex",
            value: "Triplex"
        },
        {
            label: "Fourplex",
            value: "Fourplex"
        },
        {
            label: "Property of 5+ units",
            value: "Property of 5+ units"
        }
    ],
    fr: [
        {
            label: "Maison",
            value: "Maison"
        },
        {
            label: "Condo",
            value: "Condo"
        },
        {
            label: "Maison secondaire ou chalet",
            value: "Maison secondaire ou chalet"
        },
        {
            label: "Duplex",
            value: "Duplex"
        },
        {
            label: "Triplex",
            value: "Triplex"
        },
        {
            label: "Quadruplex",
            value: "Quadruplex"
        },
        {
            label: "Property of 5+ units",
            value: "Property of 5+ units"
        }
    ]
}



// WEBPACK FOOTER //
// ./src/components/renewal-wizard/homes.js